/* eslint-disable prefer-const, one-var */
function Simpletabs(el) {
  let that = $(el),
    tabC = ($('.tabs').length) ? $('.tabs') : that.find('ul:first-child'),
    tabs = tabC.find('a[href^="#"]'),
    content = ($('.tabbed-layers').length) ? $('.tabbed-layers') : tabC.next(),
    contents = content.find('> *').hide();

  tabs.click(function onClick(e) {
    const tab = $(this);
    const thisContent = $(tab.attr('href'));
    tabs.removeClass('active');
    tab.addClass('active');
    e.preventDefault();
    contents.hide();
    thisContent.show();
  });

  if (!!window.location.hash && tabC.find(`a[href="${window.location.hash}"]`).length === 1) {
    tabC.find(`a[href="${window.location.hash}"]`).click();
  } else {
    $(tabs[0]).click();
  }
}

module.exports = Simpletabs;
